import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpHeaders } from '@angular/common/http';
import { Observable} from 'rxjs';
import { SfLocalizeService } from '@app/sf-lib/public_api';
import { NetworkService } from '../services/network.service';
import { environment } from '@env/environment';

/**
 * Interceptor responsible for passing headers/params in all requests
 * @export
 * @class AuthInterceptor
 * @implements {HttpInterceptor}
 */
@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly localize = inject(SfLocalizeService);
  private readonly networkService = inject(NetworkService);

  /**
   * Append necessary headers and/or params to all requests to the API
   * @param {HttpRequest<any>} request
   * @param {HttpHandler} next
   * @returns {Observable<HttpEvent<any>>}
   * @memberof AuthInterceptor
   */
  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    let headers: HttpHeaders = request.headers;
    if (request.url.indexOf('/upload') >= 0) {
      return next.handle(request);
    }
    headers = headers.append('Content-type', 'application/json');
    headers = headers.append('site', `ret_${this.localize.currentLang.country}`);
    headers = headers.append('langcode', this.networkService.langcode);

    // Whether this build is a preview build is decided at build time, never
    // derived from the incoming request: the hostname is attacker-controlled.
    // Status is :
    //   0    => only unpublished content
    //   1    => only published
    //   none => all contents
    if (!environment.previewMode) {
      headers = headers.append('status', '1');
    }

    request = request.clone({
      headers: headers
    });

    return next.handle(request);
  }
}
